export const getEllapsedTimeInMillisecondsFactory = () => {
    const startTimestamp = Date.now();

    return () => Date.now() - startTimestamp;
};
